import Quantity from './quantity';
import Option from './option';

class Reader {
    /** @type {?number} */
    productId;

    /** @type {number} */
    quantity = 1;

    /** @type {boolean} */
    hasOptions = false;

    /**
     * @param {HTMLButtonElement} elem
     */
    constructor({elem}) {
        this.loadAttributes(elem);
    }

    /**
     * @param {{elem: HTMLButtonElement}} data
     * @returns {Reader}
     */
    static run(data) {
        return new Reader(data);
    }

    /** @param {HTMLButtonElement} elem */
    loadAttributes(elem) {
        const data = elem.dataset;

        if (Object.entries(data).length === 0) {
            return;
        }

        if (Object.hasOwn(data, 'productId')) {
            this.productId = parseInt(data.productId, 10);
        }

        if (Object.hasOwn(data, 'quantity')) {
            this.quantity = parseInt(data.quantity, 10);
        } else {
            this.quantity = Quantity.get();
        }

        if (Object.hasOwn(data, 'hasOptions')) {
            this.hasOptions = parseInt(data.hasOptions, 10) === 1;
        } else {
            this.hasOptions = Option.showPopup();
        }
    }

    /** @return {void} */
    validate() {
        if (isNaN(this.productId) || !this.productId) {
            throw new Error('Parameter `productId` is not a number!');
        }

        if (isNaN(this.quantity) || !this.quantity) {
            throw new Error('Parameter `quantity` is not a number!');
        }
    }

    /**
     * @return {{quantity: number, products: [{product_id: ?number}], option: {}|{number:[number]}}}
     */
    getData() {
        this.validate();

        return {
            quantity: this.quantity,
            products: [{product_id: this.productId}],
            option: Option.get(),
        };
    }
}

export default Reader;
